import {fromJS, Map} from 'immutable';
import dashboardActions from '../../actions/dashboard.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {DashboardState} from '.';
import {isObject} from '../../utils/ValidationUtils';

const initialState: DashboardState = {
    products: {
        queryState: {
            keywords: '',
            locale: 'en',
            page: 0,
            start: 0,
            count: 18,
            sortBy: 'relevancy',
            sortDir: 'DESC'
        },
        loading: false,
        lastFetch: null,
        data: [],
        paging: {
            total: 0,
            start: 0,
            count: 0
        }
    },
    earnedProducts: {
        loading: false,
        lastFetch: null,
        data: {}
    },
    earnings: {
        loading: false,
        lastFetch: null,
        lifetimePayouts: 0,
        lifetimePayoutsCurrency: null,
        lastPayout: 0,
        lastPayoutCurrency: null,
        lastPayoutDate: null,
        eligibleEarnings: 0,
        eligibleEarningsCurrency: null
    }
};

export const DEFAULT_STATE = fromJS(initialState);

export const dashboardReducer = (state: Map<keyof DashboardState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        /**
         * PRODUCTS DATA
         * */
        case dashboardActions.TYPES.GET_PRODUCTS: {
            return newState.mergeIn(['products'], {
                loading: true,
                queryState: action.payload
            });
        }
        case dashboardActions.TYPES.GET_PRODUCTS_COMPLETE: {
            const {products: response} = action.payload;

            if (response && response.data) {
                const {elements, paging = initialState.products.paging} = response.data;
                const oldProducts = newState.getIn(['products', 'data']);
                const pageKey = newState.getIn(['products', 'queryState', 'page']);
                const products = isObject(elements) ? Object.values(elements) : [];
                const newMap = oldProducts.set(pageKey, products);
                return newState.mergeIn(['products'], {
                    loading: false,
                    lastFetch: Date.now(),
                    paging,
                    data: newMap
                });
            }

            return newState.updateIn(['products', 'loading'], () => false);
        }
        case dashboardActions.TYPES.GET_PRODUCTS_FAILED: {
            newState = newState.updateIn(['products', 'loading'], () => false);
            return newState;
        }
        case dashboardActions.TYPES.UPDATE_PRODUCTS_QUERY_STATE: {
            return newState.mergeIn(['products', 'queryState'], action.payload);
        }
        case dashboardActions.TYPES.RESET_PRODUCTS: {
            return newState.updateIn(['products', 'data'], () => fromJS([]));
        }

        /**
         * PRODUCT EARNINGS DATA
         * */
        case dashboardActions.TYPES.GET_EARNED_PRODUCTS: {
            newState = newState.updateIn(['earnedProducts', 'loading'], () => true);
            return newState;
        }
        case dashboardActions.TYPES.GET_EARNED_PRODUCTS_COMPLETE: {
            const {earnedProducts} = action.payload;

            if (earnedProducts && earnedProducts.data) {
                return newState.mergeIn(['earnedProducts'], {
                    loading: false,
                    lastFetch: Date.now(),
                    data: earnedProducts.data
                });
            }

            return newState.updateIn(['earnedProducts', 'loading'], () => false);
        }
        case dashboardActions.TYPES.GET_EARNED_PRODUCTS_FAILED: {
            newState = newState.updateIn(['earnedProducts', 'loading'], () => false);
            return newState;
        }

        /**
         * EARNINGS DATA
         * */
        case dashboardActions.TYPES.GET_EARNINGS_DATA: {
            return newState.updateIn(['earnings', 'loading'], () => true);
        }
        case dashboardActions.TYPES.GET_EARNINGS_DATA_COMPLETE: {
            const {earnings} = action.payload;
            if (earnings.data) {
                Object.assign(earnings.data, {lastFetch: Date.now(), loading: false});
            }
            return newState.mergeIn(['earnings'], earnings.data);
        }
        case dashboardActions.TYPES.GET_EARNINGS_DATA_FAILED: {
            return newState.updateIn(['earnings', 'loading'], () => false);
        }

        default:
            return newState;
    }
};

export default dieselReducer('dashboard', dashboardReducer);
